import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import LeadCaptureModal from '../../../components/feature/LeadCaptureModal';

export default function SistemaEmissaoCTePage() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-primary via-primary-700 to-primary-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <div className="inline-flex items-center px-4 py-2 bg-secondary/20 backdrop-blur-sm border border-secondary/30 rounded-full mb-6">
                <i className="ri-shield-check-line text-secondary mr-2"></i>
                <span className="text-white text-sm font-medium">Certificado pela SEFAZ</span>
              </div>
              <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
                Sistema de Emissão de CT-e Online
              </h1>
              <p className="text-xl text-neutral-100 mb-8 leading-relaxed">
                <strong>Emita CT-e e MDF-e</strong> de forma rápida, segura e em conformidade com a legislação. 
                O melhor <strong>emissor de CT-e</strong> para sua transportadora.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <button
                  onClick={() => setIsModalOpen(true)}
                  className="px-8 py-4 bg-secondary text-white text-lg font-semibold rounded-lg hover:bg-secondary-600 transition-all shadow-hover whitespace-nowrap cursor-pointer"
                >
                  Testar Grátis por 14 Dias
                </button>
                <Link
                  to="/funcionalidades/cte-mdfe"
                  className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white text-lg font-semibold rounded-lg hover:bg-white/20 transition-all border border-white/30 whitespace-nowrap text-center"
                >
                  Saiba Mais
                </Link>
              </div>
            </div>
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/cf1925b977143bd18e421734983876d4.jpg"
                alt="Sistema de emissão de CT-e"
                className="rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl font-bold text-neutral-900 mb-6">
              O Que é um Sistema de Emissão de CT-e?
            </h2>
            <p className="text-lg text-neutral-700 mb-6 leading-relaxed">
              Um <strong>sistema de emissão de CT-e</strong> é um software especializado que permite às transportadoras 
              <strong>emitir CT-e</strong> (Conhecimento de Transporte Eletrônico) e <strong>MDF-e</strong> (Manifesto Eletrônico de Documentos Fiscais) 
              de forma digital, integrada com a SEFAZ. O TG WEB é um <strong>emissor de CT-e</strong> completo que automatiza todo o processo 
              de emissão de documentos fiscais eletrônicos.
            </p>
            <p className="text-lg text-neutral-700 mb-8 leading-relaxed">
              Nosso <strong>programa para emissão de CT-e</strong> oferece validação automática, integração com a SEFAZ, 
              armazenamento seguro de documentos e muito mais. É o <strong>sistema para emitir CT-e</strong> ideal para 
              transportadoras de todos os portes.
            </p>

            <h2 className="text-4xl font-bold text-neutral-900 mb-6 mt-12">
              Por Que Usar um Emissor de CT-e Online?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
              <div className="bg-neutral-50 p-6 rounded-xl">
                <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-lg mb-4">
                  <i className="ri-speed-line text-2xl text-primary"></i>
                </div>
                <h3 className="text-xl font-bold text-neutral-900 mb-3">Agilidade na Emissão</h3>
                <p className="text-neutral-700">
                  Com nosso <strong>sistema para emissão de CT-e online</strong>, você emite documentos em segundos, 
                  com preenchimento automático de dados e validação em tempo real.
                </p>
              </div>
              <div className="bg-neutral-50 p-6 rounded-xl">
                <div className="w-12 h-12 flex items-center justify-center bg-secondary/10 rounded-lg mb-4">
                  <i className="ri-shield-check-line text-2xl text-secondary"></i>
                </div>
                <h3 className="text-xl font-bold text-neutral-900 mb-3">Conformidade Fiscal</h3>
                <p className="text-neutral-700">
                  Nosso <strong>emissor de CT-e</strong> está sempre atualizado com as últimas exigências da SEFAZ, 
                  garantindo que você esteja em conformidade com a legislação.
                </p>
              </div>
              <div className="bg-neutral-50 p-6 rounded-xl">
                <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-lg mb-4">
                  <i className="ri-error-warning-line text-2xl text-primary"></i>
                </div>
                <h3 className="text-xl font-bold text-neutral-900 mb-3">Redução de Erros</h3>
                <p className="text-neutral-700">
                  O <strong>software para emitir CT-e</strong> valida automaticamente todos os dados antes do envio, 
                  evitando rejeições e retrabalho na emissão de documentos.
                </p>
              </div>
              <div className="bg-neutral-50 p-6 rounded-xl">
                <div className="w-12 h-12 flex items-center justify-center bg-secondary/10 rounded-lg mb-4">
                  <i className="ri-cloud-line text-2xl text-secondary"></i>
                </div>
                <h3 className="text-xl font-bold text-neutral-900 mb-3">Acesso de Qualquer Lugar</h3>
                <p className="text-neutral-700">
                  Como é um <strong>sistema de emissão de CT-e online</strong>, você pode <strong>emitir CT-e</strong> de 
                  qualquer dispositivo com internet, sem instalação.
                </p>
              </div>
            </div>

            <h2 className="text-4xl font-bold text-neutral-900 mb-6 mt-12">
              Funcionalidades do Nosso Emissor de CT-e
            </h2>
            <ul className="space-y-4 mb-12">
              <li className="flex items-start">
                <i className="ri-check-line text-secondary text-2xl mr-3 mt-1 flex-shrink-0"></i>
                <div>
                  <strong className="text-neutral-900">Emissão de CT-e e MDF-e:</strong>
                  <span className="text-neutral-700"> Sistema completo para <strong>emitir CT-e</strong> e <strong>emitir MDF-e</strong> com todos os tipos e modelos</span>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-secondary text-2xl mr-3 mt-1 flex-shrink-0"></i>
                <div>
                  <strong className="text-neutral-900">Integração com SEFAZ:</strong>
                  <span className="text-neutral-700"> Nosso <strong>emissor de CT-e online</strong> se comunica diretamente com a SEFAZ para validação e autorização</span>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-secondary text-2xl mr-3 mt-1 flex-shrink-0"></i>
                <div>
                  <strong className="text-neutral-900">Cancelamento e Carta de Correção:</strong>
                  <span className="text-neutral-700"> Gerencie todo o ciclo de vida dos documentos fiscais eletrônicos</span>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-secondary text-2xl mr-3 mt-1 flex-shrink-0"></i>
                <div>
                  <strong className="text-neutral-900">Importação de XML:</strong>
                  <span className="text-neutral-700"> Importe NF-e para agilizar o preenchimento do CT-e</span>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-secondary text-2xl mr-3 mt-1 flex-shrink-0"></i>
                <div>
                  <strong className="text-neutral-900">Cálculo Automático de Impostos:</strong>
                  <span className="text-neutral-700"> O <strong>programa para emissão de CT-e</strong> calcula ICMS, PIS e COFINS automaticamente</span>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-secondary text-2xl mr-3 mt-1 flex-shrink-0"></i>
                <div>
                  <strong className="text-neutral-900">Geração de DACTE e DAMDFE:</strong>
                  <span className="text-neutral-700"> Documentos auxiliares gerados automaticamente após a emissão</span>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-secondary text-2xl mr-3 mt-1 flex-shrink-0"></i>
                <div>
                  <strong className="text-neutral-900">Envio Automático por Email:</strong>
                  <span className="text-neutral-700"> Envie CT-e e MDF-e automaticamente para seus clientes</span>
                </div>
              </li>
              <li className="flex items-start">
                <i className="ri-check-line text-secondary text-2xl mr-3 mt-1 flex-shrink-0"></i>
                <div>
                  <strong className="text-neutral-900">Histórico Completo:</strong>
                  <span className="text-neutral-700"> Consulte todos os documentos emitidos com filtros avançados</span>
                </div>
              </li>
            </ul>

            <h2 className="text-4xl font-bold text-neutral-900 mb-6 mt-12">
              Como Funciona a Emissão de CT-e Online?
            </h2>
            <div className="space-y-6 mb-12">
              <div className="flex items-start">
                <div className="w-10 h-10 flex items-center justify-center bg-primary text-white rounded-full font-bold mr-4 flex-shrink-0">
                  1
                </div>
                <div>
                  <h3 className="text-xl font-bold text-neutral-900 mb-2">Preencha os Dados</h3>
                  <p className="text-neutral-700">
                    Insira as informações do transporte no nosso <strong>sistema para emitir CT-e</strong>. 
                    Muitos dados são preenchidos automaticamente.
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-10 h-10 flex items-center justify-center bg-primary text-white rounded-full font-bold mr-4 flex-shrink-0">
                  2
                </div>
                <div>
                  <h3 className="text-xl font-bold text-neutral-900 mb-2">Validação Automática</h3>
                  <p className="text-neutral-700">
                    O <strong>emissor de CT-e</strong> valida todos os campos e calcula os impostos automaticamente.
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-10 h-10 flex items-center justify-center bg-primary text-white rounded-full font-bold mr-4 flex-shrink-0">
                  3
                </div>
                <div>
                  <h3 className="text-xl font-bold text-neutral-900 mb-2">Envio para SEFAZ</h3>
                  <p className="text-neutral-700">
                    O <strong>sistema de emissão de CT-e</strong> envia o documento para a SEFAZ e aguarda a autorização.
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-10 h-10 flex items-center justify-center bg-primary text-white rounded-full font-bold mr-4 flex-shrink-0">
                  4
                </div>
                <div>
                  <h3 className="text-xl font-bold text-neutral-900 mb-2">CT-e Autorizado</h3>
                  <p className="text-neutral-700">
                    Pronto! Seu CT-e está autorizado e pode ser enviado ao cliente. O DACTE é gerado automaticamente.
                  </p>
                </div>
              </div>
            </div>

            <h2 className="text-4xl font-bold text-neutral-900 mb-6 mt-12">
              Vantagens do TG WEB como Emissor de CT-e
            </h2>
            <div className="bg-gradient-to-br from-primary/5 to-secondary/5 p-8 rounded-2xl mb-12">
              <ul className="space-y-4">
                <li className="flex items-start">
                  <i className="ri-star-fill text-secondary text-xl mr-3 mt-1"></i>
                  <span className="text-neutral-700">
                    <strong>Emissão Ilimitada:</strong> Emita quantos CT-e e MDF-e precisar sem custo adicional
                  </span>
                </li>
                <li className="flex items-start">
                  <i className="ri-star-fill text-secondary text-xl mr-3 mt-1"></i>
                  <span className="text-neutral-700">
                    <strong>Sempre Atualizado:</strong> Nosso <strong>software para emitir CT-e</strong> é atualizado automaticamente com as mudanças da legislação
                  </span>
                </li>
                <li className="flex items-start">
                  <i className="ri-star-fill text-secondary text-xl mr-3 mt-1"></i>
                  <span className="text-neutral-700">
                    <strong>Suporte Especializado:</strong> Equipe pronta para ajudar em caso de dúvidas ou rejeições
                  </span>
                </li>
                <li className="flex items-start">
                  <i className="ri-star-fill text-secondary text-xl mr-3 mt-1"></i>
                  <span className="text-neutral-700">
                    <strong>Integração Completa:</strong> O <strong>emissor de CT-e</strong> faz parte de um sistema completo de gestão para transportadoras
                  </span>
                </li>
                <li className="flex items-start">
                  <i className="ri-star-fill text-secondary text-xl mr-3 mt-1"></i>
                  <span className="text-neutral-700">
                    <strong>Segurança Total:</strong> Seus dados e documentos ficam protegidos na nuvem com backup automático
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-br from-secondary via-secondary-500 to-secondary-600 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Comece a Emitir CT-e Online Hoje Mesmo
          </h2>
          <p className="text-xl text-white/90 mb-10 leading-relaxed">
            Teste grátis por 14 dias nosso <strong>sistema de emissão de CT-e</strong> e descubra como é fácil 
            <strong>emitir CT-e</strong> e <strong>MDF-e</strong> com o TG WEB
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() => setIsModalOpen(true)}
              className="px-8 py-4 bg-white text-secondary text-lg font-semibold rounded-lg hover:bg-neutral-100 transition-all shadow-hover whitespace-nowrap cursor-pointer"
            >
              Testar Grátis por 14 Dias
            </button>
            <Link
              to="/planos"
              className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white text-lg font-semibold rounded-lg hover:bg-white/20 transition-all border border-white/30 whitespace-nowrap"
            >
              Ver Planos e Preços
            </Link>
          </div>
        </div>
      </section>

      {/* Related Links Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h3 className="text-2xl font-bold text-neutral-900 mb-8 text-center">
            Explore Mais Funcionalidades do TG WEB
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <Link
              to="/funcionalidades/cte-mdfe"
              className="group p-6 bg-neutral-50 rounded-xl hover:bg-primary/5 transition-colors border border-neutral-100"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-lg mb-4 group-hover:bg-primary/20 transition-colors">
                <i className="ri-file-text-line text-2xl text-primary"></i>
              </div>
              <h4 className="font-bold text-neutral-900 mb-2 group-hover:text-primary transition-colors">
                CT-e e MDF-e
              </h4>
              <p className="text-sm text-neutral-600">
                Detalhes completos sobre emissão de documentos fiscais eletrônicos
              </p>
            </Link>

            <Link
              to="/funcionalidades/financeiro"
              className="group p-6 bg-neutral-50 rounded-xl hover:bg-primary/5 transition-colors border border-neutral-100"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-secondary/10 rounded-lg mb-4 group-hover:bg-secondary/20 transition-colors">
                <i className="ri-money-dollar-circle-line text-2xl text-secondary"></i>
              </div>
              <h4 className="font-bold text-neutral-900 mb-2 group-hover:text-primary transition-colors">
                Controle Financeiro
              </h4>
              <p className="text-sm text-neutral-600">
                Gestão completa de custos, despesas e fluxo de caixa
              </p>
            </Link>

            <Link
              to="/funcionalidades/relatorios"
              className="group p-6 bg-neutral-50 rounded-xl hover:bg-primary/5 transition-colors border border-neutral-100"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-primary/10 rounded-lg mb-4 group-hover:bg-primary/20 transition-colors">
                <i className="ri-bar-chart-box-line text-2xl text-primary"></i>
              </div>
              <h4 className="font-bold text-neutral-900 mb-2 group-hover:text-primary transition-colors">
                Relatórios Gerenciais
              </h4>
              <p className="text-sm text-neutral-600">
                Indicadores estratégicos para tomada de decisão
              </p>
            </Link>
          </div>

          {/* Quick Links */}
          <div className="mt-12 pt-8 border-t border-neutral-200">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div>
                <h4 className="font-bold text-neutral-900 mb-3 flex items-center">
                  <i className="ri-apps-line text-primary mr-2"></i>
                  Mais Funcionalidades
                </h4>
                <ul className="space-y-2 text-sm">
                  <li>
                    <Link to="/funcionalidades/estoque" className="text-neutral-600 hover:text-primary transition-colors">
                      Gestão de Estoque
                    </Link>
                  </li>
                  <li>
                    <Link to="/funcionalidades/motorista" className="text-neutral-600 hover:text-primary transition-colors">
                      Cadastro de Motoristas
                    </Link>
                  </li>
                  <li>
                    <Link to="/funcionalidades" className="text-neutral-600 hover:text-primary transition-colors">
                      Ver todas as funcionalidades
                    </Link>
                  </li>
                </ul>
              </div>

              <div>
                <h4 className="font-bold text-neutral-900 mb-3 flex items-center">
                  <i className="ri-book-open-line text-secondary mr-2"></i>
                  Recursos
                </h4>
                <ul className="space-y-2 text-sm">
                  <li>
                    <Link to="/blog" className="text-neutral-600 hover:text-primary transition-colors">
                      Blog sobre Gestão de Transportes
                    </Link>
                  </li>
                  <li>
                    <Link to="/faq" className="text-neutral-600 hover:text-primary transition-colors">
                      Perguntas Frequentes
                    </Link>
                  </li>
                  <li>
                    <Link to="/sitemap" className="text-neutral-600 hover:text-primary transition-colors">
                      Mapa do Site
                    </Link>
                  </li>
                </ul>
              </div>

              <div>
                <h4 className="font-bold text-neutral-900 mb-3 flex items-center">
                  <i className="ri-price-tag-3-line text-primary mr-2"></i>
                  Planos
                </h4>
                <ul className="space-y-2 text-sm">
                  <li>
                    <Link to="/planos" className="text-neutral-600 hover:text-primary transition-colors">
                      Planos e Preços
                    </Link>
                  </li>
                  <li>
                    <Link to="/planos" className="text-neutral-600 hover:text-primary transition-colors">
                      Sistema para Transportadora Pequena
                    </Link>
                  </li>
                  <li>
                    <Link to="/" className="text-neutral-600 hover:text-primary transition-colors">
                      Página Inicial
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <LeadCaptureModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
}
